import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ConceptSection from '../components/ConceptSection';
import { initAnalytics, trackUserJourney } from '../utils/analytics';

const ConceptPage = () => {
  useEffect(() => {
    const cleanup = initAnalytics('concept_page');
    trackUserJourney('concept_page_visit', 'learning');
    return cleanup;
  }, []);

  return (
    <>
      <Helmet>
        <title>Le Concept Sun Spot - Découverte et partage de spots panoramiques</title>
        <meta name="description" content="Découvrez le concept Sun Spot : plateforme pour explorer, partager et trouver des spots panoramiques, bancs avec vue et lieux secrets près de chez vous." />
        <link rel="canonical" href="https://sun-spot.app/concept" />
        <meta property="og:url" content="https://sun-spot.app/concept" />
        <meta property="og:title" content="Le Concept Sun Spot - Découverte de spots panoramiques" />
        <meta property="og:description" content="Concept Sun Spot : plateforme communautaire pour découvrir des spots panoramiques et points de vue exceptionnels." />
      </Helmet>
      
      <div className="pt-16">
        <ConceptSection />
      </div>
    </>
  );
};

export default ConceptPage;